<template>
  <FormKit
    type="group"
    @input="v => handleInput(v)"
  >
    <div class="flex gap-6">
      <div class="w-3/6">
        <FormKit
          type="text"
          name="first_name"
          :label="$t('sofie.name.first_name')"
          :validation="validationRules"
        />
      </div>
      <div class="w-3/5">
        <FormKit
          type="text"
          name="last_name"
          :label="$t('sofie.name.last_name')"
          :validation="validationRules"
        />
      </div>
    </div>
  </FormKit>
</template>

<script setup lang="ts">
import type {FormKitFrameworkContext} from '@formkit/core';

const props = defineProps<{
  context: FormKitFrameworkContext
}>();

const validationRules = computed(() => {
  const rules = [];

  if (props.context.attrs.required) {
    rules.push(['required']);
  }

  return rules;
});

function handleInput(value: {
  first_name: string
  last_name: string
} | undefined) {
  props.context.node.input(value);
}
</script>
